function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from '../ModalCommon.pcss';
var _React_PureComponent;
class DeclineEnrollModal extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress, hasErrors } = props;
        if (isInProgress !== state.isInProgress && isInProgress) {
            return {
                isInProgress: true
            };
        }
        if (hasErrors && state.isInProgress) {
            return {
                isInProgress: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProp) {
        const { isInProgress, hasErrors } = this.props;
        if (prevProp.isInProgress !== isInProgress && !isInProgress && !hasErrors) {
            this.onClose();
        }
    }
    async onClose() {
        await this.props.onCloseModal();
        this.props.onClearForm();
        this.setState({
            isInProgress: false
        });
    }
    onSubmit() {
        const sharingRequest = get(this.props.formValues, 'contextData');
        this.props.onSubmit(sharingRequest);
    }
    renderActions() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "modal__actions row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "quaternary",
                        labelMessage: messages.buttons.cancel,
                        className: "btn--block",
                        isDisabled: this.state.isInProgress,
                        onClick: ()=>this.onClose()
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "secondary",
                        labelMessage: messages.buttons.decline,
                        className: "btn--block btn--filled",
                        isInProgress: this.state.isInProgress,
                        onClick: ()=>this.onSubmit()
                    })
                })
            ]
        });
    }
    renderPerson() {
        const patient = get(this.props.formValues, 'contextData.patient');
        const { avatar, firstName, lastName } = patient || {};
        return /*#__PURE__*/ _jsxs("div", {
            className: cn('row align-items-center', styles.person),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: /*#__PURE__*/ _jsx(Avatar, {
                        avatarImg: avatar,
                        name: [
                            firstName,
                            lastName
                        ],
                        className: styles.item__avatar,
                        imgClassName: styles.item__avatar__img,
                        initialsClassName: styles.item__avatar__initials
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsxs("p", {
                        className: styles.person__name,
                        children: [
                            firstName,
                            " ",
                            lastName
                        ]
                    })
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Modal, {
            modalId: constants.DECLINE_ENROLL_MODAL,
            openModalId: this.props.openModalId,
            styleModifier: "md",
            headerMessage: messages.headers.declineEnrolling,
            onClose: this.props.onCloseModal,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.container,
                    children: [
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.areYouSureToDeclinePatientRequest)),
                        this.renderPerson()
                    ]
                }),
                this.renderActions()
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isInProgress: false
        };
    }
}
_define_property(DeclineEnrollModal, "propTypes", {
    // Implicit props
    activeClinicMembership: Account.shapes.clinicMembership,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    formValues: PropTypes.object,
    openModalId: PropTypes.string,
    // Implicit actions
    onSubmit: PropTypes.func,
    onCloseModal: PropTypes.func,
    onClearForm: PropTypes.func
});
const mapStateToProps = (state)=>({
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        formValues: App.selectors.formSelector(constants.MERGE_PATIENT_FORM)(state),
        openModalId: App.selectors.modal(state),
        isInProgress: selectors.isRemoveSharingRequestInProgress(state),
        hasErrors: selectors.hasRemoveSharingRequestErrors(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onSubmit: (sharingRequest)=>dispatch(actions.removeSharingRequest(sharingRequest)),
        onCloseModal: ()=>dispatch(App.actions.closeModal()),
        onClearForm: ()=>dispatch(App.actions.clearForm(constants.MERGE_PATIENT_FORM))
    });
const ConnectedDeclineEnrollModal = connect(mapStateToProps, mapDispatchToProps)(DeclineEnrollModal);
export default withStyles(styles)(ConnectedDeclineEnrollModal);
